import styles from '../article.module.css';

export const StyledAudio = (props: StyledAudioProps) => {
	const {
		id = '',
		audiopath = '',
		type = 'mp3',
		bleed,
		caption,
		captionenabled,
	} = props;
	return (
		<Audio
			id={id}
			type={type === 'mp3' ? 'audio/mpeg' : 'audio/mpeg'}
			bleed={bleed === 'on'}
			caption={caption}
			captionEnabled={captionenabled === 'on'}
			audioPath={audiopath}
		/>
	);
};

interface StyledAudioProps {
	id: string;
	audiopath: string;
	type: 'mp3';
	bleed: string;
	caption: string;
	captionenabled: string;
}

export const Audio = (props: AudioProps) => {
	let { id, type, audioPath, bleed, caption, captionEnabled } = props;
	const className = [styles['audio'], 'media', 'audio'];
	if (bleed) {
		className.push('bleed');
	}
	return (
		<figure id={id} className={className.join(' ')}>
			<audio controls>
				<source src={audioPath} type={type} />
			</audio>
			{captionEnabled && caption ? <Caption content={caption} /> : null}
		</figure>
	);
};

interface AudioProps {
	id: string;
	type: 'audio/mpeg';
	audioPath: string;
	bleed: boolean;
	caption?: string;
	captionEnabled?: boolean;
}

const Caption = ({ content }: CaptionProps) => {
	return <figcaption dangerouslySetInnerHTML={{ __html: content }} />;
};

interface CaptionProps {
	content: string;
}
